<template lang="html">
<div>
    <table class="table social-profiles"  v-if="client.social_profiles.length > 0">
        <thead>
            <tr>
                <th>Platform</th>
                <th>Profile</th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="profile in client.social_profiles">
                <td>{{ profile.vendor }}</td>
                <td>{{ profile.profile_label }}</td>
                <td>
                    <a class="btn btn-warning" :href="authUrl(profile)" v-if="profile.token_id === null">
                        <span class="fa fa-sign-in"></span>
                    </a>
                </td>
                <td><button class="btn btn-danger-outline" @click="showDeleteConfirmation(profile)">
                    <span class="fa fa-trash-o"></span>
                </button></td>
            </tr>
        </tbody>
    </table>

    <div v-else>
        No Profiles Added.
    </div>

    <div class="modal fade" id="modal-update-social-profile" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="">Update Social Profile</h4>
          </div>
          <div class="modal-body">
              Hi.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-delete-profile" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                    <h4 class="modal-title">
                        Remove Profile?
                    </h4>
                </div>
                <div class="modal-body">
                    Are you 100% sure that you would like to remove this Profile?
                </div>
                <!-- Modal Actions -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" :class="{'btn-loading': loading}" :disabled="loading" @click="deleteProfile">Yes</button>
                    <button type="button" class="btn btn-default" data-dismiss="modal">Nope</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            'activeProfile': {},
            loading: false
        }
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },

    mounted() {
        this.listen();
    },

    methods: {
        authUrl(profile) {
            switch (profile.vendor) {
                case 'Twitter':
                    return `/admin/oauth/twitter?profile_id=${profile.profile_id}&client=${this.client.slug}`;
                case 'LinkedIn':
                    return `/admin/oauth/linkedin?profile_id=${profile.profile_id}&client=${this.client.slug}`;
                default:
                    return "#";
            }
        },

        showDeleteConfirmation(profile) {
            this.activeProfile = profile;
            $('#modal-delete-profile').modal('show');
        },

        deleteProfile() {
            this.loading = true;
            let profile = this.activeProfile;
            this.$store.dispatch('client/deleteProfile', {
                profile: profile
            })
            .then((response) => {
                Bus.$emit('show-success-alert', response.message);
                $('#modal-delete-profile').modal('hide');
                this.reset();
            }).catch((error) => {
                console.log(error);
                this.loading = false;
            })
        },

        listen() {
            let self = this;
            Echo.private('social-profiles')
                .listen('SocialProfileAuthenticated', function(e) {
                    Bus.$emit('show-success-alert', 'Successfully authenticated!');
                });
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    }
}
</script>

<style scoped lang="scss">

    table.table.social-profiles {
        tbody > tr > td {
            vertical-align: middle;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/SocialProfileList.vue